import classNames from "classnames";
import ScrollView from "devextreme-react/scroll-view";
import isNumber from "lodash/isNumber";
import React, { useCallback, useMemo, useRef } from "react";
export default function ScrollbarsInner(props) {
    const { className, wrapperClassName, scrollbarRef, extraRightSpace, height, width, onScroll, showScrollbar, overlaysManager, getOverlaysContainer, hidePopoverOverlays, ...other } = props;
    const defaultScrollbarRef = useRef(null);
    const ref = scrollbarRef || defaultScrollbarRef;
    const handleScroll = useCallback((e) => {
        hidePopoverOverlays && hidePopoverOverlays();
        onScroll && onScroll(e);
    }, [hidePopoverOverlays, onScroll]);
    const needExtraRightSpace = extraRightSpace && Boolean(other.children);
    const style = useMemo(() => ({ maxWidth: props.maxWidth, maxHeight: props.maxHeight }), [props.maxWidth, props.maxHeight]);
    return (React.createElement("div", { className: classNames(wrapperClassName, needExtraRightSpace ? "scrollable-wrapper-extra-right-space" : "scrollable-wrapper") },
        React.createElement(ScrollView, { className: classNames("custom-scrollable", className), style: style, width: width, height: isNumber(height) ? Math.floor(height) : height, ref: ref, onScroll: handleScroll, showScrollbar: showScrollbar, ...other })));
}
ScrollbarsInner.displayName = "ScrollbarsInner";
